import logSummaryCallouts from '../widgets/logSummaryCallouts';
import logTable from '../widgets/logTable';
import logAttendanceTracker from '../widgets/logAttendanceTracker';
import tableBuilder from '../widgets/tableBuilder';
import logComments from '../widgets/logComments';

export default [logSummaryCallouts, logTable, logAttendanceTracker, tableBuilder, logComments];
